<div class="flex flex-col  " style="height: calc(100vh - 120px);">
  <div class="bg-green-100 border border-green-300 rounded p-1 mb-1">
  <div class="text-white font-semibold bg-green-700 text-sm px-2 py-1 rounded-t">Fast Search</div>

  <div class="grid grid-cols-1 gap-y-0 mt-1">
    <!-- Date of Filing -->
    <div class="flex items-center gap-2 min-h-[36px]">
      <label class="w-32 text-sm flex items-center m-0 p-0 mb-5">Date of Filing:</label>
      <mat-form-field appearance="outline" class="w-full dense-field m-0 p-0">
        <input matInput [matDatepicker]="picker" [(ngModel)]="searchDate" placeholder="Select Date"  (dateChange)="onFilingDateChange($event)" />
        <span matSuffix class="flex items-center gap-1">
          <button mat-icon-button (click)="picker.open()" tabindex="-1" class="h-6 w-6">
            <mat-icon fontSize="16px">calendar_today</mat-icon>
          </button>
          <button mat-icon-button (click)="clearDate()" tabindex="-1" class="h-6 w-6">
            <mat-icon fontSize="16px">refresh</mat-icon>
          </button>
        </span>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- Party Name -->
    <div class="flex items-center gap-2 min-h-[36px]">
      <label class="w-32 text-sm flex items-center m-0 p-0 mb-5">Party Name:</label>
      <mat-form-field appearance="outline" class="w-full dense-field m-0 p-0">
        <input matInput [(ngModel)]="searchPartyName" placeholder="Enter Party Name" />
        <button mat-icon-button matSuffix (click)="searchByPartyName()" tabindex="-1" class="h-6 w-6">
          <mat-icon fontSize="16px">search</mat-icon>
        </button>
      </mat-form-field>
    </div>
  </div>
</div>




  <mat-tab-group>
    <!-- Assigned Tasks Tab -->
    <mat-tab label="Tasks">
      <div class="flex w-full border-b border-solid border-slate-300 pt-2 overflow-hidden flex-col">

        <!-- First Row: Label --> 
       
    
        <!-- Second Row: Input Box & Refresh Button (Vertically Centered) -->
        <div class="flex justify-center space-x-2 w-full" *ngIf="(isSupremeCourtFlg||isCOAFlg)">
          
          <!-- Input Field -->
          <mat-form-field appearance="outline" class="flex-1" >
            <input 
              matInput 
              id="searchCaseNumber"
              type="text" 
              class="m-0 p-0" 
              [formControl]="searchQuery" 
              (keyup)="onSearch(searchQuery.value || '')" 
              placeholder="Filter By Case/Appeal Number">
          </mat-form-field>
    
          <!-- Refresh Button (Properly Centered) -->
          <button 
            mat-icon-button 
            color="primary" 
            class="flex items-center justify-center h-[70px] w-[70px]" 
            (click)="getTasks()">
            <mat-icon fontIcon="refresh">refresh</mat-icon>
          </button>
        
        </div>
    
      </div>
      <div *ngIf="isLoading" class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
      
      <!-- No Tasks Available Message -->
      <div *ngIf="!isLoading && groupedTaskKeys.length === 0" class="no-tasks">
        No tasks available
      </div>

      <ng-container *ngIf="!(isSupremeCourtFlg||isCOAFlg); else allTasksSection">
      <mat-tab-group class="category-tabs" (selectedTabChange)="onTabChange()">
        <!-- 🟦 First Instance Tab -->
        <mat-tab label="First Instance">
           <div class="flex justify-center space-x-2 w-full pt-2 overflow-x-hidden">
          
          <!-- Input Field -->
          <mat-form-field appearance="outline" class="flex-1">
            <input 
              matInput 
              id="searchCaseNumber"
              type="text" 
              class="m-0 p-0" 
              [formControl]="searchQuery" 
              (keyup)="onSearch(searchQuery.value || '')" 
              placeholder="Filter By Case/Appeal Number">
          </mat-form-field>
    
          <!-- Refresh Button (Properly Centered) -->
          <button 
            mat-icon-button 
            color="primary" 
            class="flex items-center justify-center h-[70px] w-[70px]" 
            (click)="getTasks()">
            <mat-icon fontIcon="refresh">refresh</mat-icon>
          </button>
        
        </div>
          <div *ngIf="!isLoading && getFilteredTaskKeys('FI').length > 0" class="max-h-[50vh] overflow-y-auto overflow-x-hidden">
            <div *ngFor="let group of getFilteredTaskKeys('FI')" class="mb-2">
              <div class="group-header" (click)="toggleGroup(group)">
                <span class="group-text">{{ group }}</span>
                <mat-icon class="group-icon">
                  {{ expandedGroups[group] ? 'expand_less' : 'expand_more' }}
                </mat-icon>
              </div>
              
              <div *ngIf="expandedGroups[group]" class="p-1 mt-1">
                <table mat-table [dataSource]="getFilteredTasksByCategory(group, 'FI')" class="min-w-full">
                  <ng-container matColumnDef="courtCaseNumber">
                    <th mat-header-cell *matHeaderCellDef (click)="toggleSort('courtCaseNumber')" class="cursor-pointer">
                      Case/ Appeal No
                      <mat-icon *ngIf="sortBy === 'courtCaseNumber'" fontIcon="{{ sortAscending ? 'arrow_upward' : 'arrow_downward' }}"></mat-icon>
                    </th>
                    <td mat-cell *matCellDef="let task" class="case-number-cell" matTooltip="{{task.taskDetails}}">
                      <div role="button" class="cursor-pointer text-primary" (click)="caseNumberClick(task)">
                        {{ task.courtCaseNumber }}
                      </div>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="dueDate">
                    <th mat-header-cell *matHeaderCellDef (click)="toggleSort('dueDate')" class="cursor-pointer">
                      Due
                      <mat-icon *ngIf="sortBy === 'dueDate'" fontIcon="{{ sortAscending ? 'arrow_upward' : 'arrow_downward' }}"></mat-icon>
                    </th>
                    <td mat-cell *matCellDef="let task" 
                        [ngClass]="{'text-red-700': isExpired(task.dueDate)}"
                        class="due-date-cell" matTooltip="{{task.taskDetails}}">
                      {{ task.dueDate | date: 'mediumDate' }}
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="['courtCaseNumber', 'dueDate']"></tr>
                  <tr mat-row *matRowDef="let row; columns: ['courtCaseNumber', 'dueDate'];"></tr>
                </table>
              </div>
            </div>
          </div>
        </mat-tab>

        <!-- 🟧 Appeal Tab -->
        <mat-tab label="Appeal">
           <div class="flex justify-center space-x-2 w-full pt-2 overflow-x-hidden">
          
          <!-- Input Field -->
          <mat-form-field appearance="outline" class="flex-1">
            <input 
              matInput 
              id="searchCaseNumber"
              type="text" 
              class="m-0 p-0" 
              [formControl]="searchQuery" 
              (keyup)="onSearch(searchQuery.value || '')" 
              placeholder="Filter By Case/Appeal Number">
          </mat-form-field>
    
          <!-- Refresh Button (Properly Centered) -->
          <button 
            mat-icon-button 
            color="primary" 
            class="flex items-center justify-center h-[70px] w-[70px]" 
            (click)="getTasks()">
            <mat-icon fontIcon="refresh">refresh</mat-icon>
          </button>
        
        </div>
          <div *ngIf="!isLoading && getFilteredTaskKeys('A').length > 0" class="max-h-[70vh] overflow-y-auto">
            <div *ngFor="let group of getFilteredTaskKeys('A')">
              <div class="group-header" (click)="toggleGroup(group)">
                <span class="group-text">{{ group }}</span>
                <mat-icon class="group-icon">
                  {{ expandedGroups[group] ? 'expand_less' : 'expand_more' }}
                </mat-icon>
              </div>

              <div *ngIf="expandedGroups[group]" class="p-1 pb-5">
                <table mat-table [dataSource]="getFilteredTasksByCategory(group, 'A')" class="min-w-full">
                  <ng-container matColumnDef="courtCaseNumber">
                    <th mat-header-cell *matHeaderCellDef (click)="toggleSort('courtCaseNumber')" class="cursor-pointer">
                      Case/ Appeal No
                      <mat-icon *ngIf="sortBy === 'courtCaseNumber'" fontIcon="{{ sortAscending ? 'arrow_upward' : 'arrow_downward' }}"></mat-icon>
                    </th>
                    <td mat-cell *matCellDef="let task" class="case-number-cell" matTooltip="{{task.taskDetails}}">
                      <div role="button" class="cursor-pointer text-primary" (click)="caseNumberClick(task)">
                        {{ task.courtCaseNumber }}
                      </div>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="dueDate">
                    <th mat-header-cell *matHeaderCellDef (click)="toggleSort('dueDate')" class="cursor-pointer">
                      Due
                      <mat-icon *ngIf="sortBy === 'dueDate'" fontIcon="{{ sortAscending ? 'arrow_upward' : 'arrow_downward' }}"></mat-icon>
                    </th>
                    <td mat-cell *matCellDef="let task" 
                        [ngClass]="{'text-red-700': isExpired(task.dueDate)}"
                        class="due-date-cell" matTooltip="{{task.taskDetails}}">
                      {{ task.dueDate | date: 'mediumDate' }}
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="['courtCaseNumber', 'dueDate']"></tr>
                  <tr mat-row *matRowDef="let row; columns: ['courtCaseNumber', 'dueDate'];"></tr>
                </table>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </ng-container>

    <!-- 🔸 All Tasks (for Supreme Court) -->
    <ng-template #allTasksSection>
      <div *ngIf="!isLoading && getFilteredTaskKeys().length > 0" class="max-h-[70vh] overflow-y-auto">
        <div *ngFor="let group of getFilteredTaskKeys()" class="mb-2">
          <div class="group-header" (click)="toggleGroup(group)">
            <span class="group-text">{{ group }}</span>
            <mat-icon class="group-icon">
              {{ expandedGroups[group] ? 'expand_less' : 'expand_more' }}
            </mat-icon>
          </div>

          <div *ngIf="expandedGroups[group]" class="p-1">
            <table mat-table [dataSource]="filteredTasks[group]" class="min-w-full">
              <ng-container matColumnDef="courtCaseNumber">
                <th mat-header-cell *matHeaderCellDef>Case/Appeal No</th>
                <td mat-cell *matCellDef="let task" class="cursor-pointer text-primary" (click)="caseNumberClick(task)">
                  {{ task.courtCaseNumber }}
                </td>
              </ng-container>
              <ng-container matColumnDef="dueDate">
                <th mat-header-cell *matHeaderCellDef>Due</th>
                <td mat-cell *matCellDef="let task">{{ task.dueDate | date: 'mediumDate' }}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="['courtCaseNumber','dueDate']"></tr>
              <tr mat-row *matRowDef="let row; columns: ['courtCaseNumber','dueDate'];"></tr>
            </table>
          </div>
        </div>
      </div>
    </ng-template>
    </mat-tab>

    <!-- Calendar Tab -->
    <mat-tab label="Calendar">
      <div class="mt-4 border border-gray-300">
        <mat-card>
          <div class="flex justify-between items-center  cursor-pointer" (click)="toggleCalendar()">
          </div>
          <div *ngIf="calendarExpanded" class="calendar-container" >
            
            <mat-calendar
              #calendarRef
              [selected]="selectedDate"
              [startAt]="startAtDate"
              [dateClass]="highlightHolidayDates.bind(this)"
              (selectedChange)="($event != null) ? onDateSelected($event) : null"
              (viewChanged)="applyHolidayTooltips($any($event))" 
                         
              >

              
            </mat-calendar>
          </div>
        </mat-card>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
